import { action, observable } from 'mobx'
import { validationContext, required } from 'validx'
import { COUNTRY_US } from '@/assets/data/countries'
import {
  mustBeValidTaxFormInputValue,
  mustHaveMaxLength,
  when,
} from '@/utils/validx-util'
import type { ContactAddress } from '@/features/jobs/details/tax-type/tax-prep-organizer/models'

export class AddressFieldSetViewModel {
  @observable accessor streetLine = ''
  @observable accessor city = ''
  @observable accessor region = ''
  @observable accessor postalCode = ''
  @observable accessor country = ''

  readonly validation = validationContext(this, {
    streetLine: [
      when(() => this._required, required('Street address is required')),
      mustBeValidTaxFormInputValue(),
      mustHaveMaxLength(100, 'Street address must not exceed 100 characters'),
    ],
    city: [
      when(() => this._required, required('City is required')),
      mustBeValidTaxFormInputValue(),
      mustHaveMaxLength(100, 'City must not exceed 100 characters'),
    ],
    region: [
      when(
        () => this._required && this.country === COUNTRY_US[0],
        required('State is required'),
      ),
      mustBeValidTaxFormInputValue(),
      mustHaveMaxLength(100, 'Region must not exceed 100 characters'),
    ],
    postalCode: [
      when(() => this._required, required('Zip/postal code is required')),
      mustBeValidTaxFormInputValue(),
      mustHaveMaxLength(20, 'Zip/postal code must not exceed 20 characters'),
    ],
    country: [when(() => this._required, required('Country is required'))],
  })

  constructor(private readonly _required: boolean) {}

  get required() {
    return this._required
  }

  @action.bound
  reset(data?: ContactAddress | null) {
    this.streetLine = data?.streetLine ?? ''
    this.city = data?.city ?? ''
    this.region = data?.region ?? ''
    this.postalCode = data?.postalCode ?? ''
    this.country = data?.country ?? ''

    this.validation.reset()
  }

  toProps(): ContactAddress {
    return {
      streetLine: this.streetLine || null,
      city: this.city || null,
      region: this.region || null,
      postalCode: this.postalCode || null,
      country: this.country || null,
    }
  }
}
